import React, { Component } from 'react';
import Layout from './Layout';
import Feature from './Sections/Feature';
import Social from './Sections/Social';
import Application from './Sections/Application';
import Section from './Sections/Section';
import data from './../../pages/all-data.json';
import { graphql } from 'gatsby';

class CaseStudies extends Component {
    state = {
        id: this.props.pageContext.slug,
        data: this.props.data.contentfulCase,
        active: true,
        feature: true,
    };

    componentDidMount() {
        // document.title = 'Addicta – ' + this.state.data.banner.main_title;
        document.documentElement.scrollTop = 0;
    }

    render() {
        // let slug = this.state.data.slug;
        let sections = <p>dasd</p>;
        // let sections = Object.keys(this.state.data[slug].page.section).map((section, index) => {
        //     let singleSection = this.state.data[slug].page.section[section];
        //     let pr = this.state.data[slug].page.section[section].classes;
        //     //delete singleSection.classes;
        //     let data = singleSection;

        //     if (section === 'features') {
        //         return (
        //             <Section key={index} {...data} active={data.image !== '' ? this.state.active : !this.state.active}>
        //                 {singleSection.feature.map((feature, index) => (
        //                     <Feature
        //                         key={index}
        //                         title={feature.title}
        //                         text={feature.text}
        //                         image={feature.image}
        //                         Classmain={feature.Classmain}
        //                         Classtext={feature.Classtext}
        //                         ClassimageContainer={feature.ClassimageContainer}
        //                         active={feature.img !== '' ? this.state.feature : !this.state.feature}
        //                     />
        //                 ))}
        //             </Section>
        //         );
        //     } else if (section === 'social') {
        //         return <Social key={index} {...data} />;
        //     } else if (section === 'download') {
        //         return <Application key={index} {...data} />;
        //     } else {
        //         return (
        //             <Section
        //                 key={index}
        //                 last={index === Object.keys(this.state.data[slug].page.section).length - 1 ? true : false}
        //                 {...data}
        //                 active={data.image !== '' ? this.state.active : !this.state.active}
        //             />
        //         );
        //     }
        // });

        const { data } = this.state;
        console.log(data.page[0].mainTitle);
        const paginationData = this.props.data.allContentfulCase.edges;
        const index = this.props.data.allContentfulCase.edges.findIndex(
            ({ node }) => this.props.pageContext.slug === node.slug,
        );
        console.log(data.page[0]);
        return (
            <Layout
                mainTitle={data.page[0].mainTitle}
                secondTitle={data.page[0].secondaryTitle}
                text={data.page[0].description}
                mainClass={data.slug}
                banner={data.page[0].banner.fluid}
                categories={data.page[0].categories}
                next={paginationData[index + 1]}
                prev={paginationData[index - 1]}
                active={true}
            >
                {sections}
            </Layout>
        );
    }
}
export default CaseStudies;

export const pageQuery = graphql`
    query CaseBySlug($slug: String!) {
        allContentfulCase {
            edges {
                node {
                    title
                    slug
                    image {
                        fluid(quality: 90, maxWidth: 1920) {
                            src
                        }
                    }
                }
            }
        }
        contentfulCase(slug: { eq: $slug }) {
            title
            slug
            page {
                ... on ContentfulBanner {
                    id
                    mainTitle
                    secondaryTitle
                    description
                    banner {
                        fluid(quality: 90, maxWidth: 1920) {
                            ...GatsbyContentfulFluid_withWebp
                        }
                    }
                    categories {
                        name
                        img {
                            file {
                                url
                            }
                        }
                    }
                }
                ... on ContentfulSection {
                    id
                    title
                }
            }
        }
    }
`;
// {
//   allContentfulCase {
//     edges {
//       node {
//         title
//         title
//         page {
//           ... on ContentfulBanner {
//             id
//             mainTitle
//             secondaryTitle
//             description
//             banner {
//               fluid {
//                 src
//               }
//             }
//             categories {
//               name
//               img {
//                 file {
//                   url
//                   }
//               }
//             }
//           }
//           ... on ContentfulSection {
//             id
//             title
//           }
//         }
//       }
//     }
//   }
// }

// query CaseBySlug($slug: String!) {
//     site {
//         siteMetadata {
//             title
//         }
//     }
//     contentfulCase(slug: { eq: $slug }) {
//         title
//         page {
//             ... on ContentfulBanner {
//                 id
//                 mainTitle
//                 secondaryTitle
//                 description
//                 banner {
//                     fluid {
//                         src
//                     }
//                 }
//                 categories {
//                     name
//                     img {
//                         file {
//                             url
//                         }
//                     }
//                 }
//             }
//             ... on ContentfulSection {
//                 id
//                 title
//             }
//         }
//     }
// }
